import { Component, OnInit } from '@angular/core';
import { CardsService } from '../../../resources/cards/cards.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Card } from '../../../model/card';
import { Observable } from 'rxjs/Observable';
import { Transaction } from '../../../model/transaction';

@Component({
  selector:    'app-card-details',
  templateUrl: './card-details.component.html',
  styleUrls:   [ './card-details.component.scss' ]
})
export class CardDetailsComponent implements OnInit {

  loading = true;

  card_id: number;

  card: Card;

  transactions: Transaction[];

  constructor(private route: ActivatedRoute,
              private location: Location,
              private cardsService: CardsService) {
  }

  ngOnInit() {

    const params$ = this.route.params
      .do((params) => {
        this.card_id = +params.id;
      })
      .first();

    const card$ = params$
      .switchMap(() => {
        if (isNaN(this.card_id)) {
          Observable.throw('no_id');
        } else {
          return Observable.forkJoin(
            this.cardsService.get(this.card_id),
            this.cardsService.transactions(this.card_id)
          );
        }
      });


    card$
      .subscribe(([ card, transactions ]) => {
        this.card = new Card(card);
        this.transactions = transactions;
        this.loading = false;
      }, () => this.location.back());
  }

  back() {
    this.location.back();
  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/card-details/card-details.component.ts